module.exports = "/images/transparency.svg?d0b6a8dc42416ef1ed5844838fce3ed5";